import React, { useEffect, useState, useContext } from 'react'
import Modal from '@material-ui/core/Modal'
import DialogContent from '@material-ui/core/DialogContent'
import { navigate } from 'gatsby'
import * as queryString from 'query-string'

import AnimatingLogo from 'images/inline/logo-animating.svg'
import SignInUpForm from 'components/forms/signinup/SignInUpForm'
import Card from 'components/index/Card'

import HeroBanner from 'components/index/HeroBanner'
import Lock from '@material-ui/icons/Lock'

import { getUserType } from 'global/context/sub-contexts/userContext'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import { userTypeEnum } from 'services/user'
import { checkBreakTargetingForUser } from 'services/break'
import { useSiteMetadata } from 'hooks/useSiteMetadata'

import './GuestSignUpTemplate.scss'

export const statesEnum = {
  LOADING: 'loading',
  MISSING_PARAMS: 'missing-params',
  NOT_LOGGED_IN: 'not-logged-in',
  NOT_IN_TARGET: 'not-in-target',
}

const breakIsCompleted = breakId => {
  return false
}

const checkAccess = async (permalink, breakId, setMode) => {
  const userType = getUserType()
  // console.log(`userType: ${userType}`)

  if (userType === userTypeEnum.REGISTERED) {
    const res = await checkBreakTargetingForUser(breakId)
    // console.log(`targeted: ${res.detail.targeted}`)
    if (res.detail.targeted) {
      navigate(
        `/break/${permalink}?utm_campaign=dailybreak&utm_medium=interstitial&utm_source=organic`,
      )
    } else {
      setMode(statesEnum.NOT_IN_TARGET)
    }
  } else {
    setMode(statesEnum.NOT_LOGGED_IN)
  }
}

export const LockedContent = props => {
  return (
    <div className="gated-content">
      <div className="gated-content--lock">
        <Lock style={{ fontSize: 91 }} />
        <p>{props.label}</p>
      </div>
      <div className="blur">{props.children}</div>
    </div>
  )
}

export const UnlockedContent = props => {
  return <div className="content">{props.children}</div>
}

const Breaks = ({ breaks, breakIsCompleted = false }) => {
  return (
    <div className="container">
      <div className="card-row four">
        {breaks &&
          breaks.length &&
          breaks.map((brk, i) => {
            return (
              <Card
                key={i}
                brk={brk}
                breakIsCompleted={breakIsCompleted}
                utm_source={`organic`}
                utm_medium={`interstitial`}
                utm_campaign={`dailybreak`}
              />
            )
          })}
      </div>
    </div>
  )
}

let permalink = null
let breakId = null

const GuestSignUpTemplate = ({ data }) => {
  const modal_context = useContext(modalContext)
  const { setOnLoginSuccess, showSignInModalTab } = modal_context || {}

  const [mode, setMode] = useState(statesEnum.LOADING)

  const recentBreaks = data.data.recent.nodes

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const userType = getUserType()
      const qs = queryString.parse(window.location.search)
      permalink = qs.permalink
      breakId = qs.id

      if (permalink && breakId) {
        checkAccess(permalink, breakId, setMode)
      } else {
        if (userType === userTypeEnum.REGISTERED) {
          navigate(`/`)
        } else {
          setMode(statesEnum.MISSING_PARAMS)
        }
      }
    }
  }, [])

  const handleLoginAndRegistrationSuccess = async () => {
    if (permalink && breakId) {
      checkAccess(permalink, breakId, setMode)
    } else {
      navigate(`/`)
    }
  }

  useEffect(() => {
    setOnLoginSuccess(() => handleLoginAndRegistrationSuccess)
  }, [])

  const signUpButton = (
    <>
      <button
        className="hero-button themed-button"
        onClick={showSignInModalTab}
      >
        {' '}
        Sign Up / Sign In{' '}
      </button>
    </>
  )

  const metadata = useSiteMetadata()
  const siteName = metadata.title

  const bannerContent = {
    'missing-params': {
      title: `${siteName} is full of exclusive content.`,
      text: `Unlock member-only breaks by signing up to become a ${siteName} user. Discover a world of delightful, personalized breaks and see what you’ve been missing out on today!`,
    },
    'not-logged-in': {
      title: `Guess what? You just clicked on exclusive content.`,
      text: `Unlock member-only breaks like this by signing up to become a ${siteName} user. Discover a world of delightful, personalized breaks and see what you’ve been missing out on today!`,
    },
    'not-in-target': {
      title: `Aw, snap!`,
      text: `This sponsored story is intended for a specific audience. Not to worry—there’s other awesome content in the sea! Check out other fun, customized stories just for you below.`,
    },
  }

  return (
    <section className="guest-template">
      {mode === statesEnum.LOADING && (
        <div className="loading">
          <AnimatingLogo />
        </div>
      )}
      {mode === statesEnum.MISSING_PARAMS && (
        <>
          <HeroBanner
            title={bannerContent['missing-params'].title}
            text={bannerContent['missing-params'].text}
            button={signUpButton}
          />
          <LockedContent label="Sign In to Unlock">
            <Breaks breaks={recentBreaks} />
          </LockedContent>
        </>
      )}
      {mode === statesEnum.NOT_LOGGED_IN && (
        <>
          <HeroBanner
            title={bannerContent['not-logged-in'].title}
            text={bannerContent['not-logged-in'].text}
            button={signUpButton}
          />
          <LockedContent>
            <Breaks breaks={recentBreaks} />
          </LockedContent>
        </>
      )}
      {mode === statesEnum.NOT_IN_TARGET && (
        <>
          <HeroBanner
            title={bannerContent['not-in-target'].title}
            text={bannerContent['not-in-target'].text}
          />
          <UnlockedContent>
            <Breaks breaks={recentBreaks} />
          </UnlockedContent>
        </>
      )}
    </section>
  )
}

export default GuestSignUpTemplate
